<template>
  <div class="dod-container" v-if="!loading">
    <back-button />

    <div
      class="content"
      :key="selectedCustomer ? selectedCustomer.id : 'customerDetailsContent'"
    >
      <div class="left-side">
        <customer-personal-data
          class="mb-4"
          :customer="selectedCustomer"
          @updated="handleNewUserDataLoading"
        />
        <customer-management :customer="selectedCustomer" />
      </div>
    </div>
    <div
      v-if="selectedCustomer"
      class="content"
      :key="`${selectedCustomer.id}_messages`"
    >
      <user-messages :customerId="selectedCustomer.id" />
    </div>
  </div>
</template>

<script>
import BackButton from "../../components/dod/BackButton.vue";
import CustomerManagement from "../../components/dod/CustomerManagement.vue";
import CustomerPersonalData from "../../components/dod/CustomerPersonalData.vue";
import UserMessages from "../../components/dod/UserMessages.vue";
import moment from "moment";
export default {
  components: {
    CustomerPersonalData,
    BackButton,
    UserMessages,
    CustomerManagement,
  },
  name: "DodCustomerDetails",
  data() {
    return {
      searchValue: "",
      loading: true,
    };
  },

  async mounted() {
    await this.$store.dispatch("resetCustomerDetails");
    await this.handleNewUserDataLoading();
  },

  computed: {
    urlQuery() {
      return this.$route.query;
    },
    selectedCustomer() {
      return this.$store.getters.getDodSelectedCustomer;
    },
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
  },

  watch: {
    async urlQuery() {
      await this.handleNewUserDataLoading();
    },
  },

  methods: {
    async handleNewUserDataLoading() {
      const now = moment();
      await this.$store.dispatch("getCustomerDetails", {
        customerId: this.$route.params.id,
        ordersMonth: now.get("month") + 1,
        ordersYear: now.get("year"),
      });
      await this.$store.dispatch("getCustomerMessages", {
        customerId: this.$route.params.id,
      });
      await this.$store.dispatch("getCustomerSchedule", {
        customerId: this.$route.params.id,
        ordersMonth: now.get("month") + 1,
        ordersYear: now.get("year"),
      });
      this.loading = false;

      const needScrollToMessages = this.$route.query.toMessages;
      if (needScrollToMessages) {
        setTimeout(() => {
          let messages = document.getElementById("dod-user-messages");
          if (messages) {
            messages.scrollIntoView({ behavior: "auto" });
          }
        }, 1000);
      }
    },
  },

  destroyed() {
    this.$store.dispatch("resetCustomerDetails");
  },
};
</script>

<style scoped>
.content {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  width: 100%;
}
.left-side {
  width: 100%;
  padding-top: 0;
}
</style>
